export const setTenantToLocalStorage = () => {
  const params = new URLSearchParams(window.location.search);
  const tenantId = params.get('tenantId');
  if (tenantId) localStorage.setItem('x-tenant', tenantId);
};
